import { getField, updateField } from 'vuex-map-fields';

// initial state
const state = {
    loadedDate: null,
};

// getters
const getters = {
    getField
};

// actions
const actions = {
    setLoadedDate({ commit, rootState }) {
        commit('setStateValue', { key: 'loadedDate', value: new Date() });
    },
};

// mutations
const mutations = {
    updateField,
    setStateValue(state, payload) {
        state[payload.key] = payload.value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
